__turbopack_context__.v({
  "avatarCanvas": "TutorStage-module__VFLZGq__avatarCanvas",
  "avatarFrame": "TutorStage-module__VFLZGq__avatarFrame",
  "avatarTool": "TutorStage-module__VFLZGq__avatarTool",
  "avatarTools": "TutorStage-module__VFLZGq__avatarTools",
  "fullscreenBackdrop": "TutorStage-module__VFLZGq__fullscreenBackdrop",
  "fullscreenCaption": "TutorStage-module__VFLZGq__fullscreenCaption",
  "fullscreenControls": "TutorStage-module__VFLZGq__fullscreenControls",
  "fullscreenHit": "TutorStage-module__VFLZGq__fullscreenHit",
  "fullscreenLayer": "TutorStage-module__VFLZGq__fullscreenLayer",
  "stage": "TutorStage-module__VFLZGq__stage",
  "stageHeader": "TutorStage-module__VFLZGq__stageHeader",
  "stageIconButton": "TutorStage-module__VFLZGq__stageIconButton",
  "stageMeta": "TutorStage-module__VFLZGq__stageMeta",
  "statusDetail": "TutorStage-module__VFLZGq__statusDetail",
  "thumbButton": "TutorStage-module__VFLZGq__thumbButton",
  "tutorHover": "TutorStage-module__VFLZGq__tutorHover",
  "viewDescription": "TutorStage-module__VFLZGq__viewDescription",
  "viewGroup": "TutorStage-module__VFLZGq__viewGroup",
  "viewIcon": "TutorStage-module__VFLZGq__viewIcon",
  "viewLabel": "TutorStage-module__VFLZGq__viewLabel",
  "viewMenu": "TutorStage-module__VFLZGq__viewMenu",
  "viewOption": "TutorStage-module__VFLZGq__viewOption",
  "viewPanel": "TutorStage-module__VFLZGq__viewPanel",
  "viewSection": "TutorStage-module__VFLZGq__viewSection",
  "viewSelect": "TutorStage-module__VFLZGq__viewSelect",
  "viewSelectRow": "TutorStage-module__VFLZGq__viewSelectRow",
  "wrapBelow": "TutorStage-module__VFLZGq__wrapBelow",
  "wrapFloats": "TutorStage-module__VFLZGq__wrapFloats",
  "wrapShape": "TutorStage-module__VFLZGq__wrapShape",
  "wrapSpacer": "TutorStage-module__VFLZGq__wrapSpacer",
});
